import React from "react";

export default function AlbumModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div 
        className="bg-zinc-800 p-4 sm:p-6 rounded-2xl w-full max-w-md max-h-[90vh] overflow-y-auto scrollbar-hide text-white relative"
        style={{
          backgroundImage: "url('/images/background1.png')",
          backgroundPosition: "center center",
          backgroundSize: "cover",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style jsx>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        
        <h3 className="text-lg font-bold mb-4">Álbum</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4">
          {Array(12).fill(0).map((_, index) => (
            <div 
              key={index} 
              className="rounded-lg overflow-hidden border-2 border-gray-700 bg-zinc-900 bg-opacity-50"
            >
              <div className="w-full h-24 sm:h-40 flex items-center justify-center">
                <svg className="w-8 h-8 sm:w-10 sm:h-10 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </div>
            </div>
          ))}
        </div>
        
        <button
          onClick={onClose}
          className="mt-6 px-4 py-2 bg-yellow-400 text-black rounded-full hover:bg-yellow-300 transition w-full"
        >
          Cerrar álbum
        </button>
      </div>
    </div>
  );
}